/**
 * oggetto specifico di REST per SHAPER-TEST
 */
import AppActions from '../app/app_actions'
import { AppConstants } from '../constants/AppConstants.js';
import { store } from '../store.js'
import { WebRest } from 'arm-common';

/**
 * classe Rest basata su WebRest
 */
class Rest extends WebRest {
    /*
     */
    constructor() {
        super(
            AppConstants.REST_SERVER, //
            AppConstants.REST_BASE_URL, //
            ["account/login", "authentication/loginbo"], // to skip

            // recover jsessionId
            () => {
                let app = store.getState().app;
                return app.jsessionId;
            },

            // loading, show loader
            (dispatch) => {
                dispatch(AppActions.showLoader());
            },

            // end load, hide loader
            (dispatch) => {
                dispatch(AppActions.hideLoader());
            },

            // handle error message
            (dispatch, message, statusCode, options, stacktrace) => {
                dispatch(AppActions.addNotify('DANGER', message));
                // TODO discerne sullo status code per decidere se visualizzare un errore bloccante o meno
                // es, per sessione scaduta visualizzare altro...
                /* let mesg = "<div style='font-size: 150%'>" + message + "</div>";
                 if (stacktrace) {
                     if (stacktrace.startsWith("<html>")) {
                         let stpos = stacktrace.toLowerCase();
                         mesg += "<hr /><div class='__htmlError'>";
                         // let hasStyle = stpos.indexOf("<style");
                         // if (hasStyle > 0) {
                         //    mesg += stacktrace.substring(hasStyle, stpos.indexOf("</style>", hasStyle) +
                         //         "</style>".length);
                         // }
                         let stbody = stpos.indexOf("<body");
                         stbody = stpos.indexOf(">", stbody) + 1;
                         let body = stacktrace.substring(stbody, stpos.lastIndexOf("</body>"));
                         console.log("body error html:", body);
                         mesg += body;
                         mesg += "</div>"
                     } else {
                         mesg += "<hr /><div><pre style='max-height: 65vh;" +
                             " overflow-y: auto; " +
                             " width: 95%;" +
                             " border: 1px solid #c00;'>" + stacktrace + "</pre></div>";
                     }
 
                 }
 
                 console.warn("REST SHAPER ERROR", mesg);
 
 
                 if (statusCode < 200 || (statusCode >= 400 && statusCode < 413) || statusCode >= 500)
                     __showInternalError(mesg, "Errore di comunicazione con il back-end - status code " + statusCode);
                     */
            },

            // do logout
            (dispatch) => {
                dispatch({
                    type: 'LOGOUT'
                });
            },

            // path iniziale per chiamate stubs
            "./stubs/",

            // recover serverId
            () => {
                let app = store.getState().app;
                return app.serverid;
            },

        )
    }
}

export default new Rest;